import { Button, Card, Col, Row, Typography, Spin } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";

import React from "react";
import { AdminMenuLayout, ModalSauceWarehouses } from "../../../../shared/components";
import { WrapperTabNav } from "../../../products";
import { TableSauceWarehouses } from "./TableSauceWarehouses";
import { useNavigate, useParams } from "react-router-dom";
import { saucesService } from "../../../../shared/services";
import { ISauce } from "../../../../redux/@types";
import { EditSauceForm } from "../form";
import { DrawerSauces } from "../styled";

const { Title, Text } = Typography;

export const SauceById = () => {
  const navigate = useNavigate();
  const { sauce_id } = useParams();
  const [openModalAsignedSouce, setOpenModalAsignedSouce] = React.useState<boolean>(false);
  const [openModalEdit, setOpenModalEdit] = React.useState<boolean>(false);
  const [sauce, setSauce] = React.useState<ISauce | null>(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (sauce_id) {
      setLoading(true);
      saucesService
        .get(Number(sauce_id))
        .then((res: any) => setSauce(res))
        .catch(() => setSauce(null))
        .finally(() => setLoading(false));
    }
  }, [sauce_id]);

  const handleEditSuccess = () => {
    setOpenModalEdit(false);
    if (sauce_id) {
      saucesService.get(Number(sauce_id)).then((res: any) => setSauce(res));
    }
  };

  if (loading) {
    return (
      <AdminMenuLayout pageDescription="Sauces" title="Sauces">
        <div style={{ display: "flex", justifyContent: "center", padding: 48 }}>
          <Spin size="large" />
        </div>
      </AdminMenuLayout>
    );
  }

  return (
    <AdminMenuLayout pageDescription="Sauces" title="Sauces">
      <Card>
        <Text style={{ color: "gray", cursor: "pointer" }} onClick={() => navigate("/sauces")}>
          Ir atrás
        </Text>

        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Title style={{ margin: 0 }}>
              {sauce ? sauce.name : "Salsa"}
            </Title>
            <Button
              type="primary"
              icon={<EditOutlined />}
              size="large"
              onClick={() => setOpenModalEdit(true)}
              style={{
                borderRadius: 8,
                backgroundColor: "#fa8c16",
                borderColor: "#fa8c16",
              }}
            >
              Editar salsa
            </Button>
          </Col>
        </Row>

        <WrapperTabNav
          items={[
            {
              label: `LISTADO DE SALSAS EN BODEGAS`,
              key: "3",
              children: (
                <>
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    {" "}
                    <Button
                      type="primary"
                      shape="round"
                      icon={<PlusOutlined />}
                      size="large"
                      onClick={()=>setOpenModalAsignedSouce(true)}
                    >
                      Asignar una salsa a la bodega
                    </Button>
                  </div>
                  <TableSauceWarehouses />
                </>
              ),
            },
          ]}
        />
        <ModalSauceWarehouses
          openModal={openModalAsignedSouce}
          setOpenModal={setOpenModalAsignedSouce}
        />
        <DrawerSauces
          title="Editar salsa"
          open={openModalEdit}
          width={420}
          centered
          destroyOnClose
          footer={null}
          onCancel={() => setOpenModalEdit(false)}
        >
          <EditSauceForm sauce={sauce || undefined} onSuccess={handleEditSuccess} />
        </DrawerSauces>
      </Card>
    </AdminMenuLayout>
  );
};
